import Context from "../../../context";
import { useContext } from "react";

import * as Icon from "react-bootstrap-icons";

export default function ManageAccountPageWrapper({
  shouldScroll = false,
  children,
  pageName,
  subText,
  button,
}) {
  const { contextState, setContextState } = useContext(Context);

  return (
    <div className={`page-container${shouldScroll ? "--scroll" : ""}`}>
      <div className="page-wrapper">
        <span
          className="page-back-link"
          onClick={() => {
            contextState.manageActivePage !== "overview" &&
              setContextState({
                ...contextState,
                manageActivePage: "overview",
              });

            contextState.detailActivePage !== "overview" &&
              setContextState({
                ...contextState,
                detailActivePage: "overview",
              });
          }}>
          <Icon.ChevronLeft className="page-back-link-icon" />{" "}
          <p className="page-back-link-text">Back</p>
        </span>
        <div className="page-wrapper-header">
          <h1 className="page-header-text">{pageName}</h1>
          {button && button}
        </div>
        {subText && <p className="page-header-subtext">{subText}</p>}
        {children}
      </div>
    </div>
  );
}
